exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-add[data-v-b8b2bc18] {\n    border-radius: 2px;\n}\n.empty-message[data-v-b8b2bc18] {\n    text-align: center;\n}\n.btn-view[data-v-b8b2bc18] {\n    border-radius: 3px;\n}\n.badge-group[data-v-b8b2bc18] {\n    margin: 0 4px;\n    font-size: 0.85em;\n    background-color: #dc3545;\n    color: #ffffff;\n}\n", ""]);

// exports
